import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import Card from "../Card/Card";
import { PATTERN } from "../../constants";

interface InputProps {
  name: string;
  label?: string;
  value: string;
  onChange: Function;
  placeholder: string;
  requiredText: string;
  readOnly?: boolean;
  pattern?: string;
  patternViolationText?: string;
}

interface CardTextInputProps {
  title?: string;
  innerCard?: boolean;
  className?: string;
  inputs: Array<InputProps>;
  disabled?: boolean;
}

export default function CardTextInput(props: CardTextInputProps) {
  const { t } = useTranslation();

  return (
    <Card
      title={props.title}
      innerCard={props.innerCard}
      className={props.className}
    >
      {props.inputs.map((textInput, i) => (
        <Form.Group
          className={
            "row px-171-rem" +
            (props.innerCard ? "" : i === 0 ? " pt-228-rem" : " pt-4") +
            (i === props.inputs.length - 1 ? " pb-228-rem" : "")
          }
          key={i}
        >
          {textInput.label && (
            <Form.Label
              className="font-weight-600 px-0"
              htmlFor={textInput.name}
            >
              {t(textInput.label)}
            </Form.Label>
          )}
          <Form.Control
            className={"py-075-rem" + (textInput.readOnly ? "" : " bg-white")}
            type="text"
            id={textInput.name}
            name={textInput.name}
            value={textInput.value}
            onChange={(value) => {
              textInput.onChange(value);
            }}
            placeholder={t(textInput.placeholder)}
            required
            disabled={props.disabled}
            readOnly={textInput.readOnly}
            pattern={textInput.pattern ? textInput.pattern : PATTERN.ANY}
          />
          <Form.Control.Feedback type="invalid">
            {textInput.value &&
            textInput.value.length > 0 &&
            textInput.patternViolationText
              ? t(textInput.patternViolationText)
              : t(textInput.requiredText)}
          </Form.Control.Feedback>
        </Form.Group>
      ))}
    </Card>
  );
}
